import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Row, Col } from 'react-bootstrap';
import { adqlTemplates, AdqlTemplate, applyTemplateParameters } from './adql-templates';
import { useTranslation } from 'react-i18next';

interface AdqlTemplateSelectorProps {
  onSelectTemplate: (query: string) => void;
}

const AdqlTemplateSelector: React.FC<AdqlTemplateSelectorProps> = ({
  onSelectTemplate,
}) => {
  //
  const { t } = useTranslation();
  const [selectedTemplateId, setSelectedTemplateId] = useState<string>('');
  const [selectedTemplate, setSelectedTemplate] = useState<AdqlTemplate | null>(null);
  const [parameters, setParameters] = useState<Record<string, string | number>>({});

  // Update selected template when ID changes
  useEffect(() => {
    //
    console.log('[selectedTemplateId] hook fires [adql-template-selector]');
    const template = adqlTemplates.find((t) => t.id === selectedTemplateId) || null;
    setSelectedTemplate(template);

    // Initialize parameters with default values
    if (template && template.parameters) {
      const initialParams: Record<string, string | number> = {};
      template.parameters.forEach((param) => {
        initialParams[param.name] = param.default !== undefined ? param.default : '';
      });
      setParameters(initialParams);
      const query = applyTemplateParameters(template, initialParams);
      onSelectTemplate(query);
    } else {
      setParameters({});
    }
    //
  }, [selectedTemplateId]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <label
        id="search-catalog-adql-template-label"
        className="text-colour"
        style={{
          padding: '0px 0px 5px 0px',
        }}
      >
        Select template:
      </label>
      <select
        aria-labelledby="search-catalog-adql-template-label"
        className="listbox"
        data-placeholder-shown={selectedTemplateId === '' ? 'T' : 'F'}
        value={selectedTemplateId}
        onChange={(e) => setSelectedTemplateId(e.target.value)}
      >
        <option hidden value="">
          {t('Template')}
        </option>
        {adqlTemplates.map((template) => (
          <option key={template.id} value={template.id}>
            {template.name}
          </option>
        ))}
      </select>
    </div>
  );
  //
}; // AdqlTemplateSelector
export default AdqlTemplateSelector;
